import { ErrorHandler, Provider } from '@angular/core';
import { SentryService } from '@mnz-core/services/sentry.service';

export class SentryErrorHandler implements ErrorHandler {
  constructor(private readonly _sentry: SentryService) {}

  handleError(error: Error): void {
    this._sentry.logError(error);
    throw error;
  }
}

export function errorHandlerFactory(sentry: SentryService): ErrorHandler {
  return new SentryErrorHandler(sentry);
}

export function provideErrorHandler(): Provider {
  return {
    provide: ErrorHandler,
    useFactory: errorHandlerFactory,
    deps: [SentryService]
  };
}
